import { useRef } from 'react';
import { Arrow } from './Arrow';
import { useMouseTilt } from '../hooks/useMouseTilt';

export function Hero() {
  const sceneRef = useRef(null);
  useMouseTilt(sceneRef, 14);

  return (
    <section id="top" className="hero">
      {/* Background layers */}
      <div className="hero-bg">
        <div className="hero-grain"></div>
        <div className="hero-grid"></div>
        <div className="hero-glow hero-glow-1" data-parallax="-0.18"></div>
        <div className="hero-glow hero-glow-2" data-parallax="0.12"></div>
      </div>

      <div className="container hero-inner" ref={sceneRef}>
        <div className="hero-meta" data-reveal>
          <span className="eyebrow">
            <span className="dot"></span>
            Designing Scalable Digital Products, Armenia, Yerevan
          </span>
        </div>

        <h1 className="display hero-title hero-title-full" data-reveal style={{ "--reveal-delay": "80ms" }}>
          <span className="line">I design products</span>
          <span className="line">
            that <em className="hero-em">solve</em>,
          </span>
          <span className="line">
            not just <span className="hero-amp">decorate.</span>
          </span>
        </h1>

        <div className="hero-below">
          <div className="hero-below-text">
            <p className="hero-lede" data-reveal style={{ "--reveal-delay": "180ms" }}>
              I'm <strong>Dee</strong>, a product designer who thinks in <em>systems</em>, <em>psychology</em>
              and <em>outcomes</em>. I study how people actually behave, then design the shortest path
              between them and the thing they came to do.
              <span className="hero-lede-meta">Strategy · UX research · Design psychology · Interfaces</span>
            </p>
            <div className="hero-cta" data-reveal style={{ "--reveal-delay": "260ms" }}>
              <a href="#contact" className="btn btn-primary">Solve a problem with me <Arrow /></a>
            </div>
          </div>

          <figure className="hero-portrait" data-reveal style={{ "--reveal-delay": "200ms" }} data-parallax="0.04">
            <div className="hero-portrait-frame" data-tilt="0.6">
              <img src="/assets/dee-portrait.jpg" alt="Dee" />
            </div>
            <div className="hero-portrait-caption">
              <span className="eyebrow">A, 01</span>
              <span>Photographed in the studio,<br />Yerevan · February</span>
            </div>
          </figure>
        </div>

        <div className="hero-foot">
          <div className="hero-foot-col" data-reveal style={{ "--reveal-delay": "400ms" }}>
            <span className="eyebrow">01, Method</span>
            <p>Behavioural psychology + interface craft. The why before the what.</p>
          </div>
          <div className="hero-foot-col" data-reveal style={{ "--reveal-delay": "480ms" }}>
            <span className="eyebrow">02, Outcome</span>
            <p>Activation up, churn down, support tickets quieter. Numbers, not vibes.</p>
          </div>
          <div className="hero-foot-col" data-reveal style={{ "--reveal-delay": "560ms" }}>
            <span className="eyebrow">03, Scroll</span>
            <p className="scroll-hint">
              How I think <span className="scroll-arrow">↓</span>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
